
import { computed, defineComponent } from "vue";
import { useMap } from "@/services";

export default defineComponent({
  name: "EditingLayerIndicator",
  setup() {
    const isEditingLayer = computed(() => useMap().isEditingLayer);
    return {
      isEditingLayer,
    };
  },
});
